import { TEST_HORDAK_PRODUCT_ID } from './constants';

const removeHordakIdFromArray = productIds => {
  const newArray = [...productIds];
  let findIndex;
  if (newArray[0]?.id) {
    findIndex = newArray.findIndex(
      na => na.id.toString() === TEST_HORDAK_PRODUCT_ID.toString()
    );
  }
  if (!newArray[0]?.id) {
    findIndex = newArray.findIndex(
      na => na.toString() === TEST_HORDAK_PRODUCT_ID.toString()
    );
  }
  if (findIndex > -1) newArray.splice(findIndex, 1);
  return newArray;
};

export default removeHordakIdFromArray;
